import { filter, sortBy } from 'lodash';
import pluralize from 'pluralize-ru';
import pluralizeEn from './pluralizeEn';

export const prepareSelectedFilter = (announcements) => {
  if (!announcements || typeof announcements !== 'object') {
    return [];
  }

  const types = Object.entries(announcements)
    .map(([key]) => (key ? key : undefined))
    .filter(Boolean);

  const filteredArray = filter(types, (item) => item !== 'ROW');

  const priority = { CATEGORY: 1, SECTOR: 2 };

  return sortBy(filteredArray, (item) => priority[item]);
};

export const getAnnouncementsCount = (count, i18n, t) => {
  switch (i18n.language) {
    case 'ru':
    case undefined:
      return pluralize(count, '', '%d предложение', '%d предложения', '%d предложений');
    default:
      return `${count} ${pluralizeEn(
        count,
        t('announcement_label_count'),
        t('announcements_label_count'),
      )}`;
  }
};
